import { bindable, containerless } from 'aurelia-framework';

@containerless
export class DynamicTableItem {
  @bindable
  title?: string = '';

  constructor() {}
}
